import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'
import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import useSavedArtwork from '@hooks/useSavedArtwork'

import { SavedArtworkModel } from '@models/types'

import placeholderImageUrl from '../../../../../../assets/placeholder.svg'
import styles from './styles.module.scss'

const SavedArtworkGridItem = (props: { entity: SavedArtworkModel }) => {
  const { entity: savedArtwork } = props

  const { title: artworkTitle } = savedArtwork

  const savedArtworkPayload = useSavedArtwork({ id: savedArtwork.id })

  const {
    callbacks: { launchManageSavedArtworkModal },
    firstSavedArtworkPage,
    user,
  } = savedArtworkPayload

  const createdDateTime = digObject(savedArtwork, 'dates.created.date_time')
  const createdDateTimeFormatted = DateTime.fromFormat(
    createdDateTime,
    'dd/MM/yyyy HH:mm',
  ).toFormat('h:mm a dd/MM/yyyy ')

  const thumbUrl = digObject(firstSavedArtworkPage, 'previews.thumb', '')

  const artworkPageCount = savedArtwork.pages_count
  const pagesText = artworkPageCount === 1 ? '1 Page' : `${artworkPageCount} Pages`

  return (
    <Box
      className={styles.root}
      flexDirection="column"
      onClick={launchManageSavedArtworkModal}
      variant="white"
    >
      <Image
        backgroundSize="contain"
        borderRadius="5px 5px 0 0"
        boxProps={{ backgroundColor: 'whiteGrey' }}
        height={150}
        placeholderUrl={placeholderImageUrl}
        url={thumbUrl}
      />

      <Box borderTop="1px solid" borderColor="lineColor" flexDirection="column" padding="large" paddingTop={0}>
        <ListItem
          boxProps={{ borderBottom: '1px solid', paddingY: 'large' }}
          flexDirection="column"
          showAngleIcon
        >
          <Text fontSize="small" variant="ellipsis">{artworkTitle}</Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small" variant="ellipsis">
            {pagesText}
          </Text>
        </ListItem>

        <Text color="bodyFontLightColor" fontSize="xsmall" paddingTop="large">
          {user.full_name} {createdDateTimeFormatted}
        </Text>
      </Box>
    </Box>
  )
}

export default SavedArtworkGridItem
